import PropTypes from 'prop-types';
import React from 'react';
import FormikInput from 'src/components/formik/FormikInput';
import PermissionHOC from 'src/hoc/PermissionHOC';
import { CASE_TYPES } from '../CaseConstants';

function calculateFinalInsuranceValue({
    vehicleIdvValue,
    vehicleInsuranceInterestRate,
    loadingDiscountPercentage,
    nonElectAccIdVPercentage,
    nonElectAccIdvValue,
    cndIdvPercentage,
    cndIdvValue,
    electIdvPercentage,
    electIdvValue,
    vexValue,
    ncbPercentage,
    totalPolicyPremium,
    odDiscountPercentage,
    discountPassToCustomer,
    odPremium,
    zeroDepreciationPercentage,
    consumablePercentage,
    enginePercentage,
    returnToInvoicePercentage,
    goldPlanValue,
    addonDiscountValue,
    thirdPartyValue,
    ownerValue,
    paidDriverValue,
    passengerValue,
    cngThirdPartyValue,
    empLiabValue,
    homeSecureValue,
    gstTaxPercentage,
}) {
    // convert to number
    const ratePercentage = Number(vehicleInsuranceInterestRate);

    /* eslint-disable */
  vehicleIdvValue = Number(vehicleIdvValue);
  loadingDiscountPercentage = Number(loadingDiscountPercentage);
  nonElectAccIdVPercentage = Number(nonElectAccIdVPercentage);
  nonElectAccIdvValue = Number(nonElectAccIdvValue);
  cndIdvPercentage = Number(cndIdvPercentage);
  cndIdvValue = Number(cndIdvValue);
  electIdvPercentage = Number(electIdvPercentage);
  electIdvValue = Number(electIdvValue);
  vexValue = Number(vexValue);
  ncbPercentage = Number(ncbPercentage);
  zeroDepreciationPercentage = Number(zeroDepreciationPercentage);
  consumablePercentage = Number(consumablePercentage);
  enginePercentage = Number(enginePercentage);
  returnToInvoicePercentage = Number(returnToInvoicePercentage);
  goldPlanValue = Number(goldPlanValue);
  addonDiscountValue = Number(addonDiscountValue);
  thirdPartyValue = Number(thirdPartyValue);
  ownerValue = Number(ownerValue);
  paidDriverValue = Number(paidDriverValue);
  passengerValue = Number(passengerValue);
  cngThirdPartyValue = Number(cngThirdPartyValue);
  empLiabValue = Number(empLiabValue);
  homeSecureValue = Number(homeSecureValue);
  gstTaxPercentage = Number(gstTaxPercentage);
  /* eslint-enable */
    /* eslint-disable jsx-a11y/label-has-associated-control */

    const rateValue = (vehicleIdvValue * ratePercentage) / 100;
    const loadingDiscountValue = (rateValue * loadingDiscountPercentage) / 100;

    const nonElectAccIdvCharges = (nonElectAccIdvValue * nonElectAccIdVPercentage) / 100;
    const cndIdvCharges = (cndIdvValue * cndIdvPercentage) / 100;
    // eslint-disable-next-line no-param-reassign
    cngThirdPartyValue = cndIdvCharges ? Number(cngThirdPartyValue) : 0; // cngThirdPartyValue only applicable if cndIdvCharges is present

    const electIdvCharges = (electIdvValue * electIdvPercentage) / 100;

    const odPremiumValue = rateValue
    + -loadingDiscountValue
    + nonElectAccIdvCharges
    + cndIdvCharges
    + electIdvCharges;

    const _allIdvTotal = vehicleIdvValue + nonElectAccIdvCharges + cndIdvCharges + electIdvCharges;

    const insuranceValueAfterVex = odPremiumValue - vexValue;

    const ncbValue = (insuranceValueAfterVex * ncbPercentage) / 100;
    const insuranceValueAfterNcb = insuranceValueAfterVex - ncbValue;

    const zeroDepreciationValue = (_allIdvTotal * zeroDepreciationPercentage) / 100;
    const consumableValue = (_allIdvTotal * consumablePercentage) / 100;
    const engineValue = (_allIdvTotal * enginePercentage) / 100;
    const returnToInvoiceValue = (_allIdvTotal * returnToInvoicePercentage) / 100;

    const addonOdPremiumValue = zeroDepreciationValue
    + consumableValue
    + engineValue
    + returnToInvoiceValue
    + goldPlanValue;

    const insuranceValueAfterAddonOd = insuranceValueAfterNcb + addonOdPremiumValue;

    const newOdPremiumValue = insuranceValueAfterAddonOd - addonDiscountValue;

    const comprehensiveValue = newOdPremiumValue
    + thirdPartyValue
    + ownerValue
    + paidDriverValue
    + passengerValue
    + cngThirdPartyValue
    + empLiabValue
    + homeSecureValue;

    const gstTaxValue = (comprehensiveValue * gstTaxPercentage) / 100;

    const insuranceValueWithGst = comprehensiveValue + gstTaxValue;

    return {
        vehicleIdvValue,
        ratePercentage,
        rateValue,
        loadingDiscountPercentage,
        loadingDiscountValue,
        nonElectAccIdVPercentage,
        nonElectAccIdvValue,
        nonElectAccIdvCharges,
        cndIdvPercentage,
        cndIdvValue,
        cndIdvCharges,
        electIdvPercentage,
        electIdvValue,
        electIdvCharges,
        odPremiumValue,
        vexValue,
        insuranceValueAfterVex,
        ncbPercentage,
        totalPolicyPremium,
        odDiscountPercentage,
        discountPassToCustomer,
        odPremium,
        ncbValue,
        insuranceValueAfterNcb,
        zeroDepreciationPercentage,
        zeroDepreciationValue,
        consumablePercentage,
        consumableValue,
        enginePercentage,
        engineValue,
        returnToInvoicePercentage,
        returnToInvoiceValue,
        goldPlanValue,
        addonOdPremiumValue,
        insuranceValueAfterAddonOd,
        addonDiscountValue,
        newOdPremiumValue,
        thirdPartyValue,
        ownerValue,
        paidDriverValue,
        passengerValue,
        cngThirdPartyValue,
        empLiabValue,
        homeSecureValue,
        comprehensiveValue,
        gstTaxPercentage,
        gstTaxValue,
        insuranceValueWithGst,
    };
}

function VehicleInsuranceQuotationComponent(props) {
    const {
        values,
        vehicleInsuranceInterestRate,
        thirdPartyValue,
        ownerValue,
        paidDriverValue,
        passengerValue,
        cngThirdPartyValue,
        disableSubmit,
        disableSubmitMessage,
        submitButtonText,
        permissionScope,
        caseType,
    } = props;

    const nonElectAccIdVPercentage = 4;
    const cndIdvPercentage = 4;
    const electIdvPercentage = 4;

    // CALCULATIONS ============================================================
    const {
        ratePercentage,
        rateValue,
        loadingDiscountValue,
        nonElectAccIdvCharges,
        cndIdvCharges,
        electIdvCharges,
        odPremiumValue,
        insuranceValueAfterVex,
        ncbValue,
        insuranceValueAfterNcb,
        zeroDepreciationValue,
        consumableValue,
        engineValue,
        returnToInvoiceValue,
        addonOdPremiumValue,
        insuranceValueAfterAddonOd,
        newOdPremiumValue,
        comprehensiveValue,
        gstTaxValue,
        insuranceValueWithGst,
    } = calculateFinalInsuranceValue({
        ...values,
        vehicleInsuranceInterestRate,
        nonElectAccIdVPercentage,
        cndIdvPercentage,
        electIdvPercentage,
        thirdPartyValue,
        ownerValue: caseType === CASE_TYPES.INDIVIDUAL ? ownerValue : 0,
        paidDriverValue,
        passengerValue,
        cngThirdPartyValue,
    });

    return (
        <div>
            <div className="card">
                <div className="card-body">
                    <h3>Vehicle Information Quotation</h3>

                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label>Vehicle IDV Value</label>
                            <FormikInput
                                name="vehicleIdvValue"
                                type="text"
                                className="form-control"
                            />
                        </div>
                        <div className="form-group col-md-3">
                            <label>Total Policy Premium</label>
                            <FormikInput
                                name="totalPolicyPremium"
                                type="text"
                                className="form-control"
                            />
                        </div>
                        <div className="form-group col-md-3">
                        <label>NCB (%)</label>
                            <FormikInput
                                name="ncbPercentage"
                                type="text"
                                className="form-control"
                            />
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label>OD Discount (%)</label>
                            <FormikInput
                                name="odDiscountPercentage"
                                type="text"
                                className="form-control"
                            />
                        </div>
                        <div className="form-group col-md-3">
                            <label>OD Premium</label>
                            <FormikInput
                                name="odPremium"
                                type="text"
                                className="form-control"
                            />
                        </div>
                        <div className="form-group col-md-3">
                            <label>Discount Amount Pass to customer</label>
                            <FormikInput
                                name="discountPassToCustomer"
                                type="text"
                                className="form-control"
                            />
                        </div>
                    </div>


                    {/* <div className="form-row">
                        <div className="form-group col-md-3">
                            <label>Rate (%)</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {ratePercentage}
                            </div>
                        </div>

                        <div className="form-group col-md-3">
                            <label>Rate Amount</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {rateValue}
                            </div>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label>Loading Discount (%)</label>
                            <FormikInput
                                name="loadingDiscountPercentage"
                                type="text"
                                className="form-control"
                            />
                        </div>

                        <div className="form-group col-md-3">
                            <label>Loading Discount Amount</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {loadingDiscountValue}
                            </div>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label>Non Elect ACC IDV (%)</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {nonElectAccIdVPercentage}
                            </div>
                        </div>

                        <div className="form-group col-md-3">
                            <label>Non Elect ACC IDV</label>
                            <FormikInput
                                name="nonElectAccIdvValue"
                                type="text"
                                className="form-control"
                            />
                        </div>

                        <div className="form-group col-md-3">
                            <label>Non Elect ACC IDV Charges</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {nonElectAccIdvCharges}
                            </div>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label>Elect ACC IDV (%)</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {electIdvPercentage}
                            </div>
                        </div>

                        <div className="form-group col-md-3">
                            <label>Elect ACC IDV</label>
                            <FormikInput
                                name="electIdvValue"
                                type="text"
                                className="form-control"
                            />
                        </div>

                        <div className="form-group col-md-3">
                            <label>Elect ACC IDV Charges</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {electIdvCharges}
                            </div>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label>CNG IDV (%)</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {cndIdvPercentage}
                            </div>
                        </div>

                        <div className="form-group col-md-3">
                            <label>CNG IDV</label>
                            <FormikInput
                                name="cndIdvValue"
                                type="text"
                                className="form-control"
                            />
                        </div>

                        <div className="form-group col-md-3">
                            <label>CNG IDV Charges</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {cndIdvCharges}
                            </div>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label>OD Premium</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {odPremiumValue}
                            </div>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label>V.EX</label>
                            <FormikInput
                                name="vexValue"
                                type="text"
                                className="form-control"
                            />
                        </div>
                        <div className="form-group col-md-3">
                            <label>Insurance Value After V.EX</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {insuranceValueAfterVex}
                            </div>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label>NCB (%)</label>
                            <FormikInput
                                name="ncbPercentage"
                                type="text"
                                className="form-control"
                            />
                        </div>

                        <div className="form-group col-md-3">
                            <label>NCB Amount</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {ncbValue}
                            </div>
                        </div>

                        <div className="form-group col-md-3">
                            <label>Insurance Value After NCB</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {insuranceValueAfterNcb}
                            </div>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label>Zero Depp. (%)</label>
                            <FormikInput
                                name="zeroDepreciationPercentage"
                                type="text"
                                className="form-control"
                            />
                        </div>

                        <div className="form-group col-md-3">
                            <label>Zero Depp. Amount</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {zeroDepreciationValue}
                            </div>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label>Consumable (%)</label>
                            <FormikInput
                                name="consumablePercentage"
                                type="text"
                                className="form-control"
                            />
                        </div>

                        <div className="form-group col-md-3">
                            <label>Consumable Amount</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {consumableValue}
                            </div>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label>Engine (%)</label>
                            <FormikInput
                                name="enginePercentage"
                                type="text"
                                className="form-control"
                            />
                        </div>

                        <div className="form-group col-md-3">
                            <label>Engine Amount</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {engineValue}
                            </div>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label>Return To Invoice (%)</label>
                            <FormikInput
                                name="returnToInvoicePercentage"
                                type="text"
                                className="form-control"
                            />
                        </div>

                        <div className="form-group col-md-3">
                            <label>Return To Invoice Amount</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {returnToInvoiceValue}
                            </div>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label>Gold Plan Amount</label>
                            <FormikInput
                                name="goldPlanValue"
                                type="text"
                                className="form-control"
                            />
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group col-md-4">
                            <label>Add-on Premium Amount</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {addonOdPremiumValue}
                            </div>
                        </div>

                        <div className="form-group col-md-4">
                            <label>Insurance Value After Add-on Premium</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {insuranceValueAfterAddonOd}
                            </div>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group col-md-4">
                            <label>Add-on Discount Amount</label>
                            <FormikInput
                                name="addonDiscountValue"
                                type="text"
                                className="form-control"
                            />
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label>New OD Premium Amount</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {newOdPremiumValue}
                            </div>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label>Third-Party Amount</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {thirdPartyValue}
                            </div>
                        </div>

                        <div className="form-group col-md-3">
                            <label>Owner Amount</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {ownerValue}
                            </div>
                        </div>

                        <div className="form-group col-md-3">
                            <label>Paid Driver Amount</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {paidDriverValue}
                            </div>
                        </div>

                        <div className="form-group col-md-3">
                            <label>Passenger Amount</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {passengerValue}
                            </div>
                        </div>

                        <div className="form-group col-md-3">
                            <label>CNG Third Party Amount</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {cngThirdPartyValue}
                            </div>
                        </div>

                        <div className="form-group col-md-3">
                            <label>Emp Liab Amount</label>
                            <FormikInput
                                name="empLiabValue"
                                type="text"
                                className="form-control"
                            />
                        </div>

                        <div className="form-group col-md-3">
                            <label>Home Secure Amount</label>
                            <FormikInput
                                name="homeSecureValue"
                                type="text"
                                className="form-control"
                            />
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group col-md-4">
                            <label>Comprehensive(OD+TP) Amount</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {comprehensiveValue}
                            </div>
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label>GST (%)</label>
                            <FormikInput
                                name="gstTaxPercentage"
                                type="text"
                                className="form-control"
                            />
                        </div>

                        <div className="form-group col-md-3">
                            <label>GST Amount</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {gstTaxValue}
                            </div>
                        </div>

                        <div className="form-group col-md-4">
                            <label>Insurance Value After GST</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {insuranceValueWithGst}
                            </div>
                        </div>
                    </div>

                    {disableSubmit ? (
                        <div
                            className="alert alert-success"
                            role="alert"
                        >
                            {disableSubmitMessage}
                        </div>
                    ) : (
                        <PermissionHOC
                            scope={permissionScope}
                            component={(
                                <div className="form-row">
                                    <div className="form-group">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                        >
                                            {submitButtonText}
                                        </button>
                                    </div>
                                </div>
                            )}
                        />

                    )} */}
                    {disableSubmit ? (
                        <div
                            className="alert alert-success"
                            role="alert"
                        >
                            {disableSubmitMessage}
                        </div>
                    ) : (
                        <PermissionHOC
                            scope={permissionScope}
                            component={(
                                <div className="form-row">
                                    <div className="form-group">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                        >
                                            {submitButtonText}
                                        </button>
                                    </div>
                                </div>
                            )}
                        />

                    )}
                </div>
            </div>
        </div>
    );
}

VehicleInsuranceQuotationComponent.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types, react/require-default-props
    values: PropTypes.any,
    vehicleInsuranceInterestRate: PropTypes.number,
    thirdPartyValue: PropTypes.number,
    ownerValue: PropTypes.number,
    paidDriverValue: PropTypes.number,
    passengerValue: PropTypes.number,
    cngThirdPartyValue: PropTypes.number,
    disableSubmit: PropTypes.bool.isRequired,
    disableSubmitMessage: PropTypes.string.isRequired,
    submitButtonText: PropTypes.string.isRequired,
    permissionScope: PropTypes.string.isRequired,
    caseType: PropTypes.string.isRequired,
};

VehicleInsuranceQuotationComponent.defaultProps = {
    vehicleInsuranceInterestRate: 0,
    thirdPartyValue: 0,
    ownerValue: 0,
    paidDriverValue: 0,
    passengerValue: 0,
    cngThirdPartyValue: 0,
};

export default VehicleInsuranceQuotationComponent;
